import './Services.css';
// import '../App.css'
import Fly from './flycard'
import Typical from 'react-typical'
// import Glith from './glitch';
const Services = () => {
  return (
    <section
      data-aos="zoom-in"
      className="services-container"
      name="services"
      id="services"
    >
     {/* <Glith></Glith> */}
      <h1 className="heading">Services I Provide</h1>
      <h1 className="heading">
      <Typical
        steps={['Web Designing', 2000, 'Web Development', 200]}
        loop={Infinity}
        wrapper="b"
        className="ser"
      />
      </h1>
      <Fly></Fly>

  
    </section>
  );
};

export default Services;